import { useEffect } from "react";

export default function Toast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return undefined;
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [toast, onClose]);

  if (!toast) return null;

  const isError = toast.type === "error";

  return (
    <div className="fixed right-6 top-6 z-[100] max-w-sm rounded-xl px-5 py-3 text-sm font-medium text-white shadow-xl shadow-shadow-500">
      <div className={isError ? "rounded-xl bg-red-500 px-4 py-3" : "rounded-xl bg-green-500 px-4 py-3"}>
        {toast.message}
      </div>
    </div>
  );
}
